module.exports = __webpack_public_path__ + "static/img/irole.3192b9c.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/swbnzk/irole.png
// module id = jeFS
// module chunks = 7